<template>
	<div
		:class="[
			$style['app-table__footer'],
			{
				[$style['app-table__footer--clean']]: clean,
				[$style['app-table__footer--individual']]: individual
			}
		]"
	>
		<div
			v-if="!$breakpoints.xs && !noGridOptions"
			:class="$style['app-table__footer__grid-options']"
		>
			<button
				v-testid="'display-type-grid'"
				:class="[
					$style['app-table__footer__grid-options__btn'],
					{
						[$style['app-table__footer__grid-options__btn--active']]:
							displayType === 'grid'
					}
				]"
				@click="$emit('display-type-change', 'grid')"
			>
				<FontAwesomeIcon :icon="['fal', 'th-large']" size="lg" />
			</button>
			<button
				v-testid="'display-type-table'"
				:class="[
					$style['app-table__footer__grid-options__btn'],
					{
						[$style['app-table__footer__grid-options__btn--active']]:
							displayType === 'table'
					}
				]"
				@click="$emit('display-type-change', 'table')"
			>
				<FontAwesomeIcon :icon="['fal', 'th-list']" size="lg" />
			</button>
		</div>
		<div :class="$style['app-table__footer__actions']">
			<div
				v-if="showPageOptions && !$breakpoints.xs"
				:class="$style['app-table__footer__actions__inner']"
			>
				<span>{{ $t("common.meta.perPage") }}:</span>
				<select
					v-testid="'pagination-per-page'"
					:class="$style['app-table__footer__actions__inner__select']"
					name="pages"
					@change="$emit('per-page-change', $event.target.value)"
				>
					<!-- <option
            :selected="perPage == 100"
            value="100"
          >
            100
          </option> -->
					<option :selected="perPage == 50" value="50">
						50
					</option>
					<option :selected="perPage == 20" value="20">
						20
					</option>
					<option :selected="perPage == 10" value="10">
						10
					</option>
					<option :selected="perPage == 5" value="5">
						5
					</option>
				</select>
			</div>
			<div
				v-if="!$breakpoints.xs && total"
				v-testid="'pagination'"
				:class="[
					$style['app-table__footer__actions__pages'],
					{
						[$style['app-table__footer__actions__pages--with-border']]:
							!showPageOptions && !$breakpoints.xs
					}
				]"
			>
				<span>{{ $t("common.meta.page") }}</span>
				<EditableField
					v-model="currentPage"
					v-testid="'pagination-page-selector'"
					:class="$style['app-table__footer__actions__pages__value']"
					:show-label="false"
					:show-icon="false"
					:small="true"
					small-text
					type="number"
					:save="(page) => handleSavePage(page)"
					:show-no-results="true"
				/>
				<span>{{ $t("common.meta.of") }}</span>
				<span v-testid="'pagination-total-pages'">{{ totalPages }}</span>
			</div>
			<!-- <TotalCounter
        v-if="!$breakpoints.xs &&total"
        :per-page="perPage"
        :total="total"
        :page="page"
      /> -->
			<button
				v-if="page"
				v-testid="'pagination-prev'"
				:disabled="page <= 1"
				:class="[
					$style['app-table__footer__actions__btn'],
					$style['app-table__footer__actions__btn--left'],
					{
						[$style['app-table__footer__actions__btn--disabled']]: page <= 1
					}
				]"
				@click="handleSavePage(parseInt(page) - 1)"
			>
				<FontAwesomeIcon :icon="['far', 'angle-left']" size="lg" />
			</button>
			<!-- <TotalCounter
        v-if="$breakpoints.xs && total"
        :per-page="perPage"
        :total="total"
        :page="page"
      /> -->
			<div
				v-if="$breakpoints.xs && total"
				v-testid="'pagination'"
				:class="$style['app-table__footer__actions__pages']"
			>
				<span>{{ $t("common.meta.page") }}</span>
				<EditableField
					v-model="currentPage"
					v-testid="'pagination-page-selector'"
					:class="$style['app-table__footer__actions__pages__value']"
					:show-label="false"
					:show-icon="false"
					:small="true"
					small-text
					type="number"
					:save="(page) => handleSavePage(page)"
					:show-no-results="true"
				/>
				<span>{{ $t("common.meta.of") }}</span>
				<span v-testid="'pagination-total-pages'">{{ totalPages }}</span>
			</div>
			<button
				v-if="page"
				v-testid="'pagination-next'"
				:disabled="currentPage >= totalPages"
				:class="[
					$style['app-table__footer__actions__btn'],
					$style['app-table__footer__actions__btn--right'],
					{
						[$style['app-table__footer__actions__btn--disabled']]: currentPage >= totalPages
					}
				]"
				@click="handleSavePage(parseInt(page) + 1)"
			>
				<FontAwesomeIcon :icon="['far', 'angle-right']" size="lg" />
			</button>
		</div>
	</div>
</template>

<script>
import breakpoints from '@/mixins/breakpoints'
// import TotalCounter from './TotalCounter'
import EditableField from '@/components/Essentials/EditableField'

export default {
	name: 'BaseTableFooter',
	components: {
		// TotalCounter,
		EditableField
	},
	mixins: [breakpoints],
	props: {
		page: {
			type: [String, Number],
			default: 0
		},
		showPageOptions: {
			type: Boolean,
			default: true
		},
		perPage: {
			type: [String, Number],
			default: 0
		},
		pages: {
			type: [String, Number],
			default: 0
		},
		total: {
			type: [String, Number],
			default: 0
		},
		noGridOptions: {
			type: [String, Boolean],
			default: false
		},
		individual: {
			type: [String, Boolean],
			default: true
		},
		clean: {
			type: Boolean,
			default: false
		},
		displayType: {
			type: String,
			default: 'table'
		},
		meta: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		currentPage: {
			get () {
				const normalizedPage = Number.parseInt(this.page, 10)
				return Number.isNaN(normalizedPage) ? 1 : normalizedPage
			},
			set (value) {
				this.handleSavePage(value)
			}
		},
		totalPages () {
			const total = this.meta.total || this.total
			return Math.ceil(total / this.perPage)
		}
	},
	methods: {
		handleSavePage (page) {
			const normalizedPage = Number.parseInt(page, 10)
			if ((this.totalPages > 0 && normalizedPage > this.totalPages) || (normalizedPage < 1) || Number.isNaN(normalizedPage)) {
				return
			}
			if (normalizedPage === this.currentPage) {
				return
			}
			this.$emit('page-change', Number.parseInt(Math.floor(normalizedPage), 10))
		}
	}
}
</script>

<style lang="scss" module>
	$footer-action-width: 24px + $gutter * 3;
	$footer-action-width-xs: 24px + $gutter;

	.app-table {
		&__footer {
			// border-top: 1px solid getColor(border-common);
			z-index: 2;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			background-color: getColor(surface);
			color: getColor(helper-text);
			font-size: 10px;
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
			border-top: 1px solid getColor(border-common);

			&--clean {
				box-shadow: 0 1px 3px 0 getColor(shadow-light);
			}

			&--individual {
				border-top-left-radius: 5px;
				border-top-right-radius: 5px;
			}

			&__actions {
				margin-left: auto;
				font-size: 14px;
				display: flex;

				@include media-breakpoint-only(xs) {
					margin-left: 0;
					width: 100%;
					justify-content: space-between;
				}

				&__pages {
					display: flex;
					align-items: center;

					@include media-breakpoint-up(sm) {
						padding: $gutter $gutter * 2;
					}

					&--with-border {
						border-left: 1px solid getColor(border-common);
					}

					& > * + * {
						margin-left: calc($gutter / 2);
					}

					&__value {
						color: getColor(text);
					}
				}

				&__inner {
					// border-top: 1px solid getColor(border-common);
					border-left: 1px solid getColor(border-common);
					border-right: 1px solid getColor(border-common);
					padding: $gutter * 1.5 $gutter * 2;

					&__select {
						margin-left: $gutter;
						width: 35px;
						font-size: 14px;
						color: getColor(text);
						background-color: transparent;
						border: none;
						outline: none;
						cursor: pointer;
						appearance: none;
						text-indent: 1px;
						text-overflow: "";
						background-image: url('data:image/svg+xml;charset=utf-8,<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-down fa-w-8 fa-2x"><path fill="currentColor" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z" class=""></path></svg>');
						background-position: right 0 top 2px;
						background-repeat: no-repeat;

						@include dark-mode{
							background-image: url('data:image/svg+xml;charset=utf-8,<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-down fa-w-8 fa-2x"><path fill="white" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z" class=""></path></svg>');
						}

						@include nord-mode{
							background-image: url('data:image/svg+xml;charset=utf-8,<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-down fa-w-8 fa-2x"><path fill="white" d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z" class=""></path></svg>');
						}

					}
				}

				&__btn {
					border: none;
					margin: 0;
					appearance: none;
					background-color: transparent;
					display: flex;
					align-items: center;
					justify-content: center;
					box-sizing: border-box;
					width: $footer-action-width;
					padding: $gutter * 1.5 0;
					font-size: 14px;
					color: getColor(text);
					transition: all 0.2s linear;

					@include media-breakpoint-only(xs) {
						width: $footer-action-width-xs;
					}

					&--left {
						border-left: 1px solid getColor(border-common);

						@include media-breakpoint-only(xs) {
							border-left: none;
							border-right: 1px solid getColor(border-common);
						}
					}

					&--right{
						border-left: 1px solid getColor(border-common);
					}

					&--disabled {
						color: getColor(disabled-link);
					}

					&:not(&--disabled):hover {
						background-color: getColor(hover-overlay);
						cursor: pointer;
						outline: none;
					}

					&:not(&--disabled):focus {
						outline: none;
					}
				}
			}

			&__grid-options {
				&__btn {
					padding: $gutter * 1.5 $gutter * 3;
					border: none;
					margin: 0;
					appearance: none;
					background-color: transparent;
					border-right: 1px solid getColor(border-common);
					font-size: 14px;
					color: getColor(helper-text);
					transition: all 0.2s linear;

					&--active {
						color: getColor(text);
					}

					&:hover,
					&:focus {
						background-color: getColor(hover-overlay);
						cursor: pointer;
						outline: none;
					}
				}
			}
		}
	}
</style>
